import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(() => ({
  block: {
    padding: '1.5rem',
    '&>div': {
      paddingTop: '1.5rem',
    }
  }
}));

const AuthFormGroup = ({title, children}) => {
  const classes = useStyles();
  return (
    <Paper variant="outlined" className={classes.block}>
      <Typography variant="h2" color="primary">
        {title}
      </Typography>
      {children}
    </Paper>
  );
};

AuthFormGroup.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default AuthFormGroup;
